import styled from 'styled-components';

export const StyledMixedMedias = styled.div`
  display: grid;
  align-items: center;
`;

export const MediaWrapper = styled.div<{ $show: boolean; }>`
  grid-row: 1;
  grid-column: 1 / -1;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transform: translateY(${({ $show }) => ($show ? 0 : '10%')});
  pointer-events: ${({ $show }) => ($show ? 'all' : 'none')};
  transition-property: all;
  transition-duration: .5s;
  transition-delay: ${({ $show }) => ($show ? '.5s' : '0s')};
`;
